<template>
  <Carousel :items-to-show="1.2" class="carousel-container">
    <Slide v-for="item in items" :key="item.key">
      <div class="carousel__item">
        <RichCard
            :title="item.title"
            :uri="item.openUrlAction"
            :image-uri="item.image.url"
            :image-title="item.imageTitle"
            :text="item.description"
            class="carousel-rich-card"
            height="75px"
            width="260px"
        />
      </div>
    </Slide>

    <template #addons="{ slidesCount }">
      <Navigation v-if="slidesCount > 1" />
    </template>
  </Carousel>
</template>

<script>
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Navigation, Slide } from 'vue3-carousel'
import RichCard from '@/components/RichCard.vue'

export default {
  name: 'RichCarousel',
  components: {
    Carousel,
    Navigation,
    Slide,
    RichCard
  },
  props: {
    items: {
      type: Object
    }
  }
}
</script>

<style lang="sass">

.carousel__viewport
  max-width: 310px
  margin: 0 auto
  height: 80px
  display: flex
  align-items: center

.carousel__next
  margin-right: 0

.carousel__prev
  margin-left: 0
</style>
